export const representativeWorkflowPhases = [
  { label: "Examine", kind: "system", note: "clarify + map impact" },
  { label: "Workspace setup", kind: "system", note: "repos + context" },
  { label: "Plan", kind: "system", note: "write the plan" },
  { label: "Design", kind: "system", note: "UI path when needed" },
  { label: "Approve", kind: "approval", note: "explicit approval" },
  { label: "Implement", kind: "system", note: "execute the plan" },
  { label: "Test", kind: "system", note: "tests + checks" },
  { label: "Verify", kind: "gate", note: "criteria + integration" },
  { label: "E2E coverage", kind: "gate", note: "regression path" },
  { label: "Complete", kind: "boundary", note: "report + delivery" },
];

export const phaseControlExamples = [
  {
    phase: "Examine / Plan",
    kind: "boundary",
    title: "Plan before code",
    detail: "Code edits, commits, pushes, PRs, merges, and Jira completion are blocked while planning is incomplete.",
  },
  {
    phase: "Approve",
    kind: "approval",
    title: "Human approval",
    detail: "Implementation waits for explicit user approval when the workflow enters its approval phase.",
  },
  {
    phase: "Implement",
    kind: "system",
    title: "Build inside scope",
    detail: "Code changes are allowed; push, PR creation, merge, and Jira completion remain blocked until later controls pass.",
  },
  {
    phase: "Verify / E2E",
    kind: "gate",
    title: "Validate before delivery",
    detail: "Tests, acceptance criteria, and required regression coverage determine whether work can advance.",
  },
  {
    phase: "Review complete",
    kind: "approval",
    title: "Record the review",
    detail: "Review workflows can require a completion report before the review task is allowed to finish.",
  },
];

export const roleResponsibilityRows = [
  { phase: "Examine", businessAnalyst: "Responsible", architect: "Consulted", developer: "Consulted", handoff: "BA → Architect" },
  { phase: "Plan", businessAnalyst: "Consulted", architect: "Responsible", developer: "Consulted", handoff: "Architect → operator" },
  { phase: "Implement", businessAnalyst: "Consulted", architect: "Consulted", developer: "Responsible", handoff: "Developer → verify" },
];

export const reworkLoops = [
  {
    label: "Standard task",
    flow: ["Verify", "failure", "Implement", "Verify"],
    detail: "Verification failure and tests-needing-fixes return work to implementation.",
  },
  {
    label: "Bugfix",
    flow: ["Reproduce", "Analyze", "Plan", "Fix", "Verify"],
    detail: "Cannot reproduce returns to reproduction; a failed verification returns to the fix.",
  },
  {
    label: "Review",
    flow: ["Review", "changes", "Request changes", "Review"],
    detail: "Review and test failures route to a bounded request-changes path.",
  },
];

export const governedExecutionSteps = [
  { label: "Start / resume", method: "start_development · resume_workflow" },
  { label: "Load current state", method: "phase · workflow · plan · branch" },
  { label: "Phase-specific guidance", method: "whats_next" },
  { label: "Agent action + plan update", method: "work inside the current boundary" },
  { label: "Transition request", method: "proceed_to_phase" },
  { label: "Policy validation", method: "role · transition · review · gates" },
  { label: "Persist next state", method: "new phase + context + history" },
];

export const workflowFamilies = [
  "Standard task",
  "Bugfix",
  "Agent task",
  "Review / rework",
  "Collaborative task",
];
